import { combineReducers } from '@reduxjs/toolkit'
import authReducer from '@/features/auth/store/authSlice'
import bankReducer from './bankSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  bank: bankReducer,
})

export default rootReducer
